export default __webpack_public_path__ + "static/media/mob_preland_8.02e4752b.jpg";